<template>
<div>
  <navbar/>
  <div class="main-frame">
    <div class="menu-component">
        <Menu />
    </div>
    <div class="page-router-component">
      <div>
          <router-view></router-view>
      </div>
    </div>
  </div>
</div>   
</template>

<script>
import navbar         from '../navbar.vue'
import axios          from 'axios'
import {SERVER_PATH}  from '../../config'
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import Menu           from './Menu.vue'
import {EventBus}       from '../../eventBus'

export default {
  name: 'Dashboard',
  components: {
    navbar,
    Menu
  },
  data () {
    return {
      username: '',
      email: '',
    }
  },
  methods: {
		...mapActions([
			'retrieveToken',
			'logout'
		]),
		handleLoginFormSubmit() {
			this.$store.dispatch('retrieveToken', {
				email: this.email,
				password: this.password
			})
		},
    emitMethod() {
      EventBus.$emit('logged-in', 'loggedin');
    },
		logout() {
			localStorage.removeItem('usertoken')
			axios.post(`${SERVER_PATH}users/auth/logout`)
			.then((response) => {
				console.log(response)
			})
		}
  },
  computed: mapGetters([
    'getToken',
    'loggedIn',
    'getUser'
  ]),
  created () {
    console.log('created')
  }
}
</script>

<style scoped>
::-webkit-scrollbar { 
   display:unset !important; 
}
.main-frame{
  margin-left: auto;
  margin-right: auto;
  max-width: 1600px ;
  padding: 2%;
  padding-bottom: 25px;
  /* height: 750px; */
  padding-right: 0px !important;
  overflow: hidden;
  display: flex;
}
.menu-component {
  vertical-align: top;
  overflow: hidden !important;
  display: inline-block;
  width: 12vw !important;
  min-width: 150px;
  margin-top: 10px;
  height: 100%;  border-right: 1px solid #434857;
  max-width: 280px;
  min-height: 680px;
}
@media screen and (max-width: 1200px){
  .page-router-component {
      width: 100% !important;
      margin-top: 0px !important;
      padding-left: unset !important;
  }
}

</style>